export enum TidStatusDto {
    ACTIVE = "ATTIVO", SUSPENDED = "SOSPESO", NOT_ASSIGNED = "CENSITO"
}